<template>

  <div>
    <div style="width: 100%;">
      <img src="../../productAndService/banner_01.png" alt="产品与服务" style="width: 100%; height: auto;">
    </div>

    <!-- 头部切换 -->
    <div class="wd100 pdtop" style="width: 1318px;margin: 40px auto;position: relative;z-index: 199;">
      <div class="breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb-list">
            <li class="breadcrumb-item"><a @click="active('/')">首页></a></li>
            <li class="breadcrumb-item"><a href="#">产品与服务></a></li>
            <li class="breadcrumb-item">数字化软件</li>
          </ol>
        </nav>
      </div>
      <div class="navigation">
        <div class="navigation-title">数字化软件</div>
        <div class="navigation-link-2s" style="line-height: 2">
          <a href="#" class="navigation-link-2" :class="{ active: activeLink === 'patent' }"
             @click.prevent="selectLink('patent')">企业数字化转型辅导</a>
          <span class="separator">|</span>
          <a href="#" class="navigation-link-2" :class="{ active: activeLink === 'trademark'  }"
             @click.prevent="selectLink('trademark')">企业数字化诊断</a>
          <span class="separator">|</span>
          <a href="#" class="navigation-link-2" :class="{ active: activeLink === 'copyright' }"
             @click.prevent="selectLink('copyright')">企业ERP软件定制开发</a>
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link-2" :class="{ active: activeLink === '4' }"-->
<!--             @click.prevent="selectLink('4')">AI视觉检测</a>-->
        </div>
        <div class="navigation-link-2s">

        </div>
      </div>
    </div>

  ·
    <!--企业数字化转型介绍start******************************************************************************************************************************************************************************-->
    <div v-show="patentShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 2200px">
        <div>
          <span class="titleSty">企业数字化转型介绍
          <span class="spanSty">Introduce</span></span>
        </div>
        <div class="container1">
          <div class="text-container">
            <div class="text-containerdiv">
              <p class="pstyle2" style="line-height: 2">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数字化转型是指企业或组织在业务运营、数据处理、客户服务等方面，通过采用信息技术和数字化手段，对传统的业务流程、组织结构、企业文化等进行改革和转型，以
                适应快速变化的市场环境和客户需求，提高企业的竞争力和可持续性发展能力。<br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;安贝森数字化规划旨在帮助企业在数字化时代构筑可持续发展竞争优势，释放数字活力，全面提升数字化水平，重构企业核心竞争力。安贝森强调数字化战略规划要从全
                局视角出发，站在企业未来发展的整体高度，以数字化思维，全面剖析企业各项业务的价值链流程和结合数字化现状，为实现企业未来发展的战略目标，对企业数字化发展目
                标和方向制订基本谋划，定义出企业数字化建设的景、使命、目标和战略，规划出企业数字化建设的未来架构和后续落地执行的数字化建设路径图，推动企业数字化战略目标
                的实现，达到总体拥有成本最低。
              </p>
            </div>
          </div>
        </div>

        <div style="width: 1255px;position: absolute; margin-top: 280px;">
          <div class="flowchart-container-updated">
            <img src="./shuzihua.png" alt="流程图背景" class="flowchart-background-updated">
            <div class="step-texts-updated">
              <div class="step-text step1-updated">
                <h3>技术革新</h3>
                <p>随着云计算、大数据、人工智能等技术的快速发展企业面临数字化转型的迫切需求。</p>
              </div>
              <div class="step-text step2-updated">
                <h3>市场竞争</h3>
                <p>数字化转型成为企业提升竞争力、适应市场变化的必要手段。</p>
              </div>
              <div class="step-text step3-updated">
                <h3>客户需求</h3>
                <p>消费者行为和需求的变化推动企业进行数字化转型以满足个性化需求。</p>
              </div>
              <div class="step-text step4-updated">
                <h3>资源有限</h3>
                <p>中小企业在资金、技术、人才等方面相对薄弱。</p>
              </div>
              <div class="step-text step5-updated">
                <h3>传统思维</h3>
                <p>部分中小企业对数字化转型的认识不足，缺乏创新思维和转型动力。</p>
              </div>
              <div class="step-text step6-updated">
                <h3>转型风险</h3>
                <p>数字化转型过程中可能面临技术风险、数据安全风险等挑战。</p>
              </div>
            </div>
          </div>
        </div>


        <div style="width: 1255px;position: absolute; margin-top: 620px;">
          <div class="flowchart-container-updated3">
            <!-- 步骤1 -->
            <div class="step-1 step1-updated3">
              <img src="./goukuang.png" alt="业务数字化" class="step-background1">
              <h3 class="titleh3">业务数字化</h3>
              <div class="step-text-1">
                <p>将传统的业务流程、生产制造、供应链管理等环节进行数字化改</p>
                <p>造，提高业务运营的效率和质量。</p>
              </div>
            </div>

            <!-- 步骤2 -->
            <div class="step-1 step2-updated3">
              <img src="./goukuang.png" alt="数据数字化" class="step-background2">
              <h3 class="titleh3">数据数字化</h3>
              <div class="step-text-1">
                <p>通过数据采集、存储、分析和应用，实现数据资源的整合和共享，为企业的决策和运营提供科学依据。</p>
              </div>
            </div>

            <!-- 步骤3 -->
            <div class="step-1 step3-updated3">
              <img src="./goukuang.png" alt="组织数字化" class="step-background3">
              <h3 class="titleh3">组织数字化</h3>
              <div class="step-text-1">
                <p>通过建立数字化企业文化、数字化组织架构、数字化沟通机制等，提高企业的灵活性和反应速度，适应市场变化和客户需求。</p>
              </div>
            </div>

            <!-- 步骤4 -->
            <div class="step-1 step4-updated3">
              <img src="./goukuang.png" alt="服务数字化" class="step-background4">
              <h3 class="titleh3">服务数字化</h3>
              <div class="step-text-1">
                <p>将传统的客户服务模式进行数字化改造，通过互联网、移动应用、社交媒体等渠道，提供更加便捷、高效、个性化的客户服务。</p>
              </div>
            </div>
          </div>
        </div>

        <div style="position: absolute;margin-top: 1080px;width: 1192px">
          <span class="titleSty">企业数字化转型的优势
          <span class="spanSty">Advantage</span></span>


          <div class="bqcontainer"  style="margin-top: 30px">
            <img src="./youshi3.png"  alt="bj"/>
            <div class="bqtext-overlay">
              <div class="bqbox" style="margin-left:10px;">
                <p class="ph3" style="font-size: 20px;font-weight: 600;">提高业务运营效率和质量</p>
                <p>数字化技术可以优化业务流程，降</p>
                <p>低成本，提高生产效率和质量。</p>
              </div>
              <div class="bqbox" style="margin-left: 31px">
                <p class="ph3" style="font-size: 20px;font-weight: 600;">优化数据处理和分析能力</p>
                <p>数字化技术可以实现数据的实时采</p>
                <p>集和快速分析，为企业决策提供科</p>
                <p>学依据。</p>
              </div>
              <div class="bqbox" style="margin-left: 29px">
                <p class="ph3" style="font-size: 20px;font-weight: 600">提高客户体验和服务质量</p>
                <p>数字化技术可以提供更加便捷、高</p>
                <p>效、个性化的客户服务，提高客户</p>
                <p>满意度和忠诚度。</p>
              </div>
              <div class="bqbox" style="margin-left: 30px">
                <p class="ph3" style="font-size: 20px;font-weight: 600;">增强企业核心竞争力</p>
                <p>数字化技术可以使企业更加适应市</p>
                <p>场变化和客户需求，提高企业的竞</p>
                <p>争力。</p>
              </div>
            </div>
          </div>
        </div>

        <div style="position: absolute;margin-top: 1535px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList customStyle="position: absolute;margin-top: 1580px;width: 1200px;margin-left: -25px;"/>
      </div>
    </div>
    <!--企业数字化转型介绍end******************************************************************************************************************************************************************************-->


    <!--企业数字化诊断介start*******************************************************************************************************************************************************************************-->
    <div v-show="trademarkShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 1850px">
        <div>
          <span class="titleSty">企业数字化诊断介
          <span class="spanSty">Introduce</span></span>
        </div>
        <div class="container1">
          <div class="text-container">
            <div class="text-containerdiv">
              <p class="pstyle2" style="line-height: 2">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;企业数字化诊断，是指通过对企业现有业务流程、组织结构、信息系统等方面进行全面评估，识别数字化转型的瓶颈和机会，为制定数字化转型战略提供决策依据。这一
                过程有助于企业认清自身在数字化方面的短板，明确转型目标和路径。这一过程通常涉及多个方面，包括技术、流程、人员、数据和文化等。企业数字化诊断是数字化转型的
                重要起点，它有助于企业认清自身在数字化方面的短板和优势，为制定转型战略提供决策依据。随着数字化技术的不断发展和普及，企业数字化诊断将越来越成为企业不可或
                缺的一项工作。未来，我们可以期待更多的企业能够重视数字化诊断，积极开展相关工作，以推动企业的数字化转型进程。
              </p>
            </div>
          </div>
        </div>

        <div style="width: 1255px;position: absolute; margin-top: 180px;">
          <div class="tj-container">
            <div class="tj-box">
              <div class="tj-header">业务流程诊断</div>
              <div class="tj-content">
                <p>关注企业内部的各个业务环节，包括生产、销售、采购、财务等。通过对业务流程的梳理和分析，
                  发现其中的痛点、堵点，以及潜在的优化空间。同时，还需要评估业务流程与数字化技术的结合程度，
                  以确定哪些环节可以通过数字化手段实现提效降本。</p>
              </div>
            </div>
            <div class="tj-box">
              <div class="tj-header">组织结构诊断</div>
              <div class="tj-content">
                <p>分析企业的组织架构、职责划分以及协作机制等方面。通过诊断，可以发现组织结构中可能存在的冗余、
                  重叠或低效环节，以及各部门之间协作不畅的问题。在此基础上，
                  可以提出优化组织结构的建议，以适应企业数字化转型的需求。</p>
              </div>
            </div>
            <div class="tj-box">
              <div class="tj-header">信息系统诊断</div>
              <div class="tj-content">
                <p>对企业现有信息系统进行全面梳理和评估。这包括对企业所使用的软硬件设施、数据资源、网络安全等方面的检查。通过诊断，可以发现信息系统在性能、稳定性、安全性等方面存在的问题，为后续的数字化转型提供技术支撑和改进方向。</p>
              </div>
            </div>
          </div>
        </div>


        <!--流程-->
        <div style="position: absolute;margin-top: 515px;width: 1255px">
          <span class="titleSty">数字化诊断的流程与方法
          <span class="spanSty">Process and method</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 585px;">
          <div class="process-container">
            <img src="./lct.png" alt="背景图片" class="process-background-image">
            <div class="step step11">明确诊断目标</div>
            <div class="step step12">识别问题和挑战</div>
            <div class="step step13">制定实施计划</div>
            <div class="step step14">持续改进</div>
            <div class="step step15">监控和评估</div>
            <div class="step step16">收集和分析数据</div>
            <div class="step step17">制定改进建议</div>
          </div>
        </div>



        <!--服务流程-->
        <div style="position: absolute;margin-top: 830px;width: 1255px">
          <span class="titleSty">服务流程
          <span class="spanSty">Service process</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 920px;">
          <div class="flowchart-container-updated">
            <img src="./gj008.png" alt="流程图背景" class="flowchart-background-updated">
            <div class="step-texts-updated">
              <div class="step-text step11-updated">全方位咨询顾问</div>
              <div class="step-text step12-updated">一对一专家服务</div>
              <div class="step-text step13-updated">资料准备</div>
              <div class="step-text step14-updated">申报后全程跟进</div>
              <div class="step-text step15-updated">认定后跟踪服务</div>
              <div class="step-text step16-updated">办理完成</div>
            </div>
          </div>
        </div>

        <div style="position: absolute;margin-top: 1150px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList customStyle="position: absolute;margin-top: 1210px;width: 1200px;margin-left: -25px;"/>
      </div>
    </div>
    <!--企业数字化诊断介end*******************************************************************************************************************************************************************************-->


    <!--企业ERP软件定制开发start******************************************************************************************************************************************************************************-->
    <div v-show="copyrightShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 1950px">
        <div>
          <span class="titleSty">ERP介绍
          <span class="spanSty">ERP introduce</span></span>
        </div>
        <div class="container1">
          <div class="text-container">
            <div class="text-containerdiv">
              <p class="pstyle2" style="line-height: 2">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ERP是企业资源规划的简称，用于帮助企业管理和优化各种业务流程。ERP系统的业务范围非常广泛，涵盖了财务管理、人力资源、供应链管理、客户服务、采购等各个环
                节。其核心功能在于通过一个集成式的平台，将这些分散的业务流程整合在一起，从而提高企业运营的效率和透明度。ERP软件常被称为企业的“记录系统”，因为它能够全
                面记录和追踪企业的各种运营活动，提供一个统一、准确的业务视图，帮助企业实现精细化管理。
              </p>
            </div>
          </div>
        </div>

        <div style="width: 1255px;position: absolute; margin-top: 180px;">
          <div class="containera">
          <!-- 第一个 div -->
          <div class="content-boxa" >
            <img src="./erp.png" alt="ERP 图片" class="imagea">
            <div class="texta">
              <h3>构建统一安全架构</h3>
              <p class="pstyle2">ERP 系统依托专业的专家支持、端到端的流程和创新的解决方案，践行安全至上原则，能够建立标准的基础架构并确保网络安全。</p>
            </div>
          </div>

          <!-- 第二个 div -->
          <div class="content-boxa" style="margin-left: 62px">
            <img src="./erp2.png" alt="ERP 图片" class="imagea">
            <div class="texta">
              <h3>提高安全性与合规性</h3>
              <p class="pstyle2">阅读 IDC 调查报告，了解 400 多家企业客户对本地和云端 ERP 管理系统的信任度，以及他们对安全性、隐私性、合规性和 ESG 优先事项的排序情况。</p>
            </div>
          </div>
        </div>
        </div>


        <div style="position: absolute;margin-top: 680px;width: 1255px">
          <span class="titleSty">ERP业务应用
          <span class="spanSty"> ERP business application</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 785px;">
          <div class="containerb">
            <!-- 背景图片 -->
            <img src="./yewuyingyong.png" alt="功能图" class="imageb">
            <div class="textbox textbox0b">
              <p class="titleherp">财务领域</p>
            </div>
            <div class="textbox textbox11b">
              <p class="titleherp">采购</p>
            </div>
            <div class="textbox textbox12b">
              <p class="titleherp">销售</p>
            </div>
            <div class="textbox textbox13b">
              <p class="titleherp">资产管理</p>
            </div>
            <div class="textbox textbox14b">
              <p class="titleherp">供应链</p>
            </div>
            <div class="textbox textbox15b">
              <p class="titleherp">人力资源管理</p>
            </div>
            <div class="textbox textbox16b">
              <p class="titleherp">服务</p>
            </div>
            <div class="textbox textbox17b">
              <p class="titleherp">制造</p>
            </div>


            <div class="textbox textbox1b">
              <p>利用&nbsp;AI&nbsp;分析功能，实时预测并应对供应链中断。</p>
            </div>
            <div class="textbox textbox2b">
              <p>使用&nbsp;AI&nbsp;技术发现技能缺口，提升员工技能并加强HR互动。</p>
            </div>
            <div class="textbox textbox3b">
              <p>利用&nbsp;AI&nbsp;驱动的洞察，顺畅交付项目并提升客户体验。</p>
            </div>
            <div class="textbox textbox4b">
              <p>借助由&nbsp;AI&nbsp;驱动的最新ERP功能，</p>
              <p>革新制造运营。</p>
            </div>

            <div class="textbox textbox5b">
              <p>利用&nbsp;AI&nbsp;驱动的财务计划功能，</p>
              <p>优化投资并实现卓越运营。</p>
            </div>

             <div class="textbox textbox6b">
              <p>借助由&nbsp;AI&nbsp;驱动的流程和智能</p>
              <p>洞察，革新采购运营。</p>
            </div>

            <div class="textbox textbox7b">
              <p>利用&nbsp;AI&nbsp;开展个性化的客户互动</p>
              <p>，并预测销售机会。</p>
            </div>

            <div class="textbox textbox8b">
              <p>规范维护流程，确保高效的利用</p>
              <p>资产。</p>
            </div>
          </div>
        </div>


        <div style="position: absolute;margin-top: 1070px;width: 1255px">
          <span class="titleSty">企业ERP管理系统
          <span class="spanSty"> Enterprise ERP Management System</span></span>
        </div>
        <div style="width: 1192px;position: absolute; margin-top: 1120px;">
          <div class="text-containerdiv">
            <p class="pstyle2" style="line-height: 2">
              目前企业常用的ERP管理系统多为云ERP系统，因此在基础架构的维护上就为企业节省了大量的时间与精力。用户在维护企业ERP管理系统时只需关注应用层面的事务，如：
            </p>
            <p class="pstyle2" style="line-height: 2">
              1、数据管理：企业ERP管理系统涉及大量的数据收集和存储，因此在维护时需要注意系统内数据的备份、清理和监测，以防数据的意外丢失、保证数据的完整性和一致性。
            </p>
            <p class="pstyle2" style="line-height: 2">
              2、安全维护：企业ERP管理系统内的数据大多涉及企业机密，因此安全问题不容忽视。企业在维护ERP系统安全性时，可以使用用户访问权限设置、安全审计和漏洞修复等措
              施，并设置防火墙等防护设施，避免系统受到外部攻击。
            </p>
            <p class="pstyle2" style="line-height: 2">
              3、技术培训：云端的企业ERP管理系统也在不断地进行改造升级，所以企业也需要不断适应新的系统变化，应及时安排使用者对新模式、新功能进行学习，以快速掌握系统的
              使用。
            </p>
          </div>
        </div>

        <div style="position: absolute;margin-top: 1430px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList customStyle="position: absolute;margin-top: 1480px;width: 1200px;margin-left: -25px;"/>
      </div>
    </div>
    <!--企业ERP软件定制开发end******************************************************************************************************************************************************************************-->

    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height:150px">
    </div>
  </div>


</template>
<style scoped>
@import 'digitalsoftware.css';
</style>
<script>
import AdvantageList from '../common/advantageList.vue';

export default {
  components: {AdvantageList},
  data() {
    return {
      activeLink: 'copyright',
      patentShow: false,
      trademarkShow: false,
      copyrightShow: true,
      softwareShow: false,
    }
  },

  methods: {
    selectLink(link) {

      // 重置所有模块的显示状态为 false
      this.patentShow = false;
      this.trademarkShow = false;
      this.copyrightShow = false;
      this.softwareShow = false;

      // 根据点击的链接设置对应模块的显示状态为 true
      if (link === 'patent') {
        this.patentShow = true;
      } else if (link === 'trademark') {
        this.trademarkShow = true;
      } else if (link === 'copyright') {
        this.copyrightShow = true;
      } else if (link === 'software') {
        this.softwareShow = true;
      }

      this.activeLink = link; // 更新当前选中的链接

    },
  },
  mounted: function () {

  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/service/digitalsoftware/digitalsoftware.vue